/* Scandic Naturals — theme.js (no dependencies) */
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: { root: '/' }, strings: {} };
  const root = (T.routes.root || '/').replace(/\/$/, '');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || T.moneyFormat || '₹{{amount}}';
    const withDelims = (num, dec, t = ',', d = '.') => {
      const fixed = (num / 100).toFixed(dec);
      const parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t);
      let out = parts[0] + (parts[1] ? d + parts[1] : '');
      return out;
    };
    const m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    let val = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': val = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': val = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelims(cents, 0, '.', ','); break;
      default: val = withDelims(cents, 2);
    }
    val = val.replace(/[.,]00$/, ''); // match money_without_trailing_zeros
    return format.replace(/\{\{\s*\w+\s*\}\}/, val).replace(/<[^>]*>/g, '');
  }
  window.theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg, isError) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Cart state ---------- */
  async function refreshCartUI(cart) {
    if (!cart) cart = await fetch(root + '/cart.js').then(r => r.json());
    $$('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    const fc = $('[data-float-cart]');
    if (fc) {
      fc.classList.toggle('is-empty', cart.item_count === 0);
      $('[data-float-count]', fc).textContent = cart.item_count === 1 ? T.strings.itemOne : (T.strings.itemOther || '__n__ items').replace('__n__', cart.item_count);
      $('[data-float-total]', fc).textContent = formatMoney(cart.total_price);
      const first = cart.items[0];
      const th = $('[data-float-thumb]', fc);
      if (th) {
        th.textContent = '';
        if (first && first.image) {
          const im = document.createElement('img');
          im.src = first.image + (first.image.indexOf('?') > -1 ? '&' : '?') + 'width=80';
          im.alt = '';
          th.appendChild(im);
        }
      }
      fc.classList.remove('is-bump'); void fc.offsetWidth; fc.classList.add('is-bump');
    }
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    return cart;
  }

  async function addToCart(items) {
    const res = await fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  /* ---------- Slide cart drawer ---------- */
  const drawerEl = () => $('#CartDrawer');
  function cartActionFor() {
    const a = T.cartActions || {};
    const t = T.template || '';
    if (t === 'cart') return 'cart-page';
    if (t === 'index') return a.index || 'drawer';
    if (t === 'collection') return a.collection || 'cart';
    if (t === 'product') return a.product || 'cart';
    return a.other || 'drawer';
  }
  async function renderDrawer(html) {
    const d = drawerEl();
    if (!d) return;
    if (!html) {
      const data = await fetch(root + '/?sections=cart-drawer').then(r => r.json());
      html = data['cart-drawer'];
    }
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer-inner]');
    const cur = $('[data-cart-drawer-inner]', d);
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }
  let lastFocus = null;
  async function openDrawer(skipRender) {
    const d = drawerEl();
    if (!d) { window.location.href = T.routes.cart; return; }
    lastFocus = document.activeElement;
    if (!skipRender) { try { await renderDrawer(); } catch (e) {} }
    d.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => { d.classList.add('is-open'); const pnl = $('.cdrawer__panel', d); pnl && pnl.focus(); });
  }
  function closeDrawer() {
    const d = drawerEl();
    if (!d || d.hidden) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { d.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.theme.openCartDrawer = openDrawer;
  async function afterAdd() {
    const act = cartActionFor();
    if (act === 'cart' || act === 'cart-page') { window.location.href = T.routes.cart; return true; }
    if (act === 'drawer' && drawerEl()) { await refreshCartUI(); await openDrawer(); return true; }
    return false;
  }
  async function changeDrawerLine(line, quantity) {
    const d = drawerEl(); if (!d) return;
    d.classList.add('is-loading');
    try {
      const res = await fetch(root + '/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'] })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await renderDrawer(data.sections && data.sections['cart-drawer']);
      await refreshCartUI(data);
    } catch (err) { toast(err.message, true); try { await renderDrawer(); } catch (e2) {} }
    finally { d.classList.remove('is-loading'); }
  }
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-dline-qty]');
    if (i) changeDrawerLine(parseInt(i.dataset.dlineQty, 10), Math.max(0, parseInt(i.value || 0, 10)));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-dline-remove]');
    if (rm) { e.preventDefault(); changeDrawerLine(parseInt(rm.dataset.dlineRemove, 10), 0); return; }
    if (e.target.closest('[data-drawer-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    const icon = e.target.closest('[data-cart-icon], .header__icon[href="' + T.routes.cart + '"], [data-float-cart]');
    if (icon && T.cartIconDrawer && T.template !== 'cart' && drawerEl()) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* Any quick-add form: product cards, hot choices */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    if (btn) btn.classList.add('is-loading');
    try {
      await addToCart([{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }]);
      if (form.hasAttribute('data-cart-reload')) {
        await rerenderCart();
        toast(T.strings.added || 'Added to cart');
      } else if (form.hasAttribute('data-drawer-refresh')) {
        await renderDrawer();
        await refreshCartUI();
      } else if (await afterAdd()) {
        return;
      } else {
        await refreshCartUI();
        if (btn) {
          const html = btn.innerHTML;
          btn.classList.add('is-done');
          btn.textContent = T.strings.addedShort || '✓';
          setTimeout(() => { btn.classList.remove('is-done'); btn.innerHTML = html; }, 1500);
        }
        toast(T.strings.added || 'Added to cart');
      }
    } catch (err) {
      toast(err.message, true);
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    const s = $('#HeaderSearch');
    if (!s) return;
    s.hidden = !s.hidden;
    if (!s.hidden) $('input', s).focus();
  }));

  /* Drawer */
  const drawer = $('#MenuDrawer');
  function toggleDrawer(open) {
    if (!drawer) return;
    if (open) { drawer.hidden = false; requestAnimationFrame(() => drawer.classList.add('is-open')); document.body.style.overflow = 'hidden'; }
    else { drawer.classList.remove('is-open'); document.body.style.overflow = ''; setTimeout(() => { drawer.hidden = true; }, 300); }
  }
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => toggleDrawer(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => toggleDrawer(false)));

  /* Announcement rotation */
  $$('[data-announce]').forEach(bar => {
    const items = $$('.announce__item', bar);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, parseInt(bar.dataset.speed || 4, 10) * 1000);
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.hero__slide', hero);
    const dots = $$('.hero__dot', hero);
    if (slides.length < 2) return;
    let i = 0, timer;
    const go = (n) => {
      slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
    };
    const auto = hero.dataset.autoplay !== 'false' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const play = () => { clearInterval(timer); if (auto) timer = setInterval(() => go(i + 1), parseInt(hero.dataset.speed || 5, 10) * 1000); };
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); play(); }));
    const hp = $('[data-hero-prev]', hero), hn = $('[data-hero-next]', hero);
    hp && hp.addEventListener('click', () => { go(i - 1); play(); });
    hn && hn.addEventListener('click', () => { go(i + 1); play(); });
    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', play);
    let x0 = null;
    hero.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', e => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    play();
  });

  /* ---------- Sliders ---------- */
  function initSlider(sl) {
    if (sl.dataset.ready) return;
    sl.dataset.ready = '1';
    const track = $('.slider__track', sl);
    const prev = $('.slider__btn--prev', sl);
    const next = $('.slider__btn--next', sl);
    const bar = $('.slider__progress span', sl);
    if (!track) return;
    const step = () => {
      const first = track.children[0];
      return first ? first.getBoundingClientRect().width + 16 : track.clientWidth;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
      if (bar) {
        const ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, .12)) - 1) * 100 : 0) + '%)';
        bar.parentElement.hidden = max <= 4;
      }
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() * 2 }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step() * 2 }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(wrap => {
    const tabs = $$('[data-tab]', wrap);
    const panels = $$('[data-panel]', wrap);
    tabs.forEach(tab => tab.addEventListener('click', () => {
      tabs.forEach(t => { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
      panels.forEach(p => p.classList.remove('is-active'));
      tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true');
      const p = panels.find(p => p.dataset.panel === tab.dataset.tab);
      if (p) { p.classList.add('is-active'); $$('[data-slider]', p).forEach(s => { delete s.dataset.ready; initSlider(s); }); }
    }));
  });

  /* ---------- Modal (login popup) ---------- */
  const loginModal = $('#LoginModal');
  function openModal(m) {
    if (!m) return;
    m.hidden = false;
    document.body.style.overflow = 'hidden';
    const f = $('input:not([type=hidden])', m);
    f && setTimeout(() => f.focus(), 60);
  }
  function closeModal(m) {
    if (!m) return;
    m.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-login-open]');
    if (opener && loginModal) { e.preventDefault(); openModal(loginModal); return; }
    const closer = e.target.closest('[data-modal-close]');
    if (closer) closeModal(closer.closest('[data-modal]'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { $$('[data-modal]:not([hidden])').forEach(closeModal); toggleDrawer(false); }
  });
  if (loginModal && ($('[data-login-has-errors]', loginModal) || $('[data-login-autoopen]'))) openModal(loginModal);

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    const input = $('input', b.closest('.qty'));
    if (!input) return;
    const min = parseInt(input.min || 0, 10);
    let v = parseInt(input.value || 0, 10) + (b.dataset.qtyBtn === 'plus' ? 1 : -1);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page ---------- */
  function cartSection() { return $('[data-cart-section]'); }
  async function rerenderCart(html) {
    const sec = cartSection();
    if (!sec) return refreshCartUI();
    const id = sec.dataset.cartSection;
    if (!html) html = await fetch(root + '/cart?section_id=' + encodeURIComponent(id)).then(r => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-section]');
    if (fresh) {
      sec.innerHTML = fresh.innerHTML;
      $$('[data-slider]', sec).forEach(initSlider);
    }
    return refreshCartUI();
  }
  async function changeLine(line, quantity) {
    const sec = cartSection();
    const row = $('[data-line="' + line + '"]', sec);
    row && row.classList.add('is-loading');
    try {
      const res = await fetch(root + '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [sec.dataset.cartSection], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
      await rerenderCart(data.sections && data.sections[sec.dataset.cartSection]);
    } catch (err) {
      toast(err.message, true);
      rerenderCart();
    }
  }
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(parseInt(input.dataset.lineQty, 10), Math.max(0, parseInt(input.value || 0, 10)));
  });
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-line-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.dataset.lineRemove, 10), 0); return; }
    const bt = e.target.closest('[data-breakup-toggle]');
    if (bt) {
      const box = document.getElementById(bt.getAttribute('aria-controls'));
      const open = bt.getAttribute('aria-expanded') !== 'true';
      bt.setAttribute('aria-expanded', open);
      if (box) box.hidden = !open;
    }
  });
  /* Coupon codes (Shopify cart discount API, no app) */
  async function setDiscount(codes, msgOk) {
    const sec = cartSection();
    const box = $('[data-coupon]');
    box && box.classList.add('is-loading');
    try {
      const res = await fetch(root + '/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), sections: sec ? [sec.dataset.cartSection] : [], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || T.strings.error);
      await rerenderCart(sec && data.sections ? data.sections[sec.dataset.cartSection] : null);
      const applied = (data.discount_codes || []).filter(d => d.applicable).map(d => d.code.toUpperCase());
      const want = codes[codes.length - 1];
      if (want && msgOk) toast(applied.includes(want.toUpperCase()) ? T.strings.couponOk : T.strings.couponFail, !applied.includes(want.toUpperCase()));
    } catch (err) {
      toast(err.message, true);
    } finally { const b = $('[data-coupon]'); b && b.classList.remove('is-loading'); }
  }
  const currentCodes = () => $$('[data-coupon-remove]').map(b => b.dataset.couponRemove);
  document.addEventListener('click', (e) => {
    const ap = e.target.closest('[data-coupon-apply]');
    const sg = e.target.closest('[data-coupon-code]');
    const rm = e.target.closest('[data-coupon-remove]');
    if (ap || sg) {
      const code = sg ? sg.dataset.couponCode : ($('[data-coupon-input]') || {}).value;
      if (!code || !code.trim()) return;
      const codes = currentCodes().filter(c => c.toUpperCase() !== code.trim().toUpperCase()).concat(code.trim());
      setDiscount(codes, true);
    } else if (rm) {
      setDiscount(currentCodes().filter(c => c !== rm.dataset.couponRemove), false);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('[data-coupon-input]')) { e.preventDefault(); const b = $('[data-coupon-apply]'); b && b.click(); }
  });

  let noteTimer;
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    clearTimeout(noteTimer);
    const note = e.target.value;
    noteTimer = setTimeout(() => fetch(root + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note }) }), 500);
  });

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(initProduct);

  function initProduct(el) {
    const json = $('[data-product-json]', el);
    if (!json) return;
    const product = JSON.parse(json.textContent);
    const form = $('[data-product-form]', el);
    const idInput = form && $('input[name="id"]', form);
    const addBtn = $('[data-add-btn]', el);
    const buyBtn = $('[data-buy-btn]', el);
    const couponPct = parseInt(el.dataset.couponPercent || 0, 10);

    /* gallery */
    const slides = $$('.gallery__slide', el);
    const thumbs = $$('.gallery__thumb', el);
    const dots = $$('.gallery__dots span', el);
    let gi = Math.max(0, slides.findIndex(s => s.classList.contains('is-active')));
    const showSlide = (n) => {
      if (!slides.length) return;
      n = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === n));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === n));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === n));
      const t = thumbs[n];
      if (t && t.offsetParent) {
        const box = t.parentElement;
        box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, top: t.offsetTop - box.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
      }
      gi = n;
    };
    thumbs.forEach((t, k) => t.addEventListener('click', () => showSlide(k)));
    const gp = $('.gallery__nav--prev', el), gn = $('.gallery__nav--next', el);
    gp && gp.addEventListener('click', () => showSlide(gi - 1));
    gn && gn.addEventListener('click', () => showSlide(gi + 1));
    const gm = $('.gallery__main', el);
    if (gm) {
      let x0 = null;
      gm.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      gm.addEventListener('touchend', e => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) showSlide(gi + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* variants */
    const current = () => {
      const opts = $$('[data-option-index]', el).map(group => {
        const sel = $('select', group);
        if (sel) return sel.value;
        const c = $('input:checked', group);
        return c ? c.value : null;
      });
      return product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    };
    const renderVariant = (v) => {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      const set = (sel, html) => $$(sel, el).forEach(n => { n.innerHTML = html; });
      set('[data-price]', formatMoney(v.price));
      const hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      $$('[data-compare]', el).forEach(n => { n.hidden = !hasCmp; n.innerHTML = hasCmp ? formatMoney(v.compare_at_price) : ''; });
      const off = hasCmp ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      $$('[data-off]', el).forEach(n => { n.hidden = !off; n.textContent = off ? T.strings.off.replace('__p__', off) : ''; });
      $$('[data-save]', el).forEach(n => { n.hidden = !hasCmp; n.textContent = hasCmp ? T.strings.save.replace('__a__', formatMoney(v.compare_at_price - v.price)) : ''; });
      if (couponPct) set('[data-coupon-price]', formatMoney(Math.round((v.price - Math.floor(v.price * couponPct / 100)) / 100) * 100));
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? addBtn.dataset.label : (T.strings.soldOut || 'Sold out'); }
      $$('[data-sticky-add]').forEach(b => { b.disabled = !v.available; });
      if (buyBtn) buyBtn.hidden = !v.available;
      if (v.featured_media) {
        const k = slides.findIndex(s => s.dataset.mediaId == v.featured_media.id);
        if (k > -1) showSlide(k);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };
    el.addEventListener('change', (e) => { if (e.target.closest('[data-option-index]')) renderVariant(current()); });

    /* add / buy */
    const qtyInput = $('[data-product-qty]', el);
    async function add(buyNow) {
      const v = current() || product.variants.find(x => String(x.id) === String(idInput && idInput.value)) || product.variants[0];
      const q = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10));
      const b = buyNow ? buyBtn : addBtn;
      b && b.classList.add('is-loading');
      try {
        await addToCart([{ id: v.id, quantity: q }]);
        if (buyNow) { window.location.href = root + '/checkout'; return; }
        if (await afterAdd()) return;
        await refreshCartUI();
        toast(T.strings.added || 'Added to cart');
      } catch (err) { toast(err.message, true); }
      finally { b && b.classList.remove('is-loading'); }
    }
    form && form.addEventListener('submit', (e) => { e.preventDefault(); add(false); });
    buyBtn && buyBtn.addEventListener('click', (e) => { e.preventDefault(); add(true); });
    $$('[data-sticky-add]').forEach(b => b.addEventListener('click', () => add(false)));

    /* sticky add bar (mobile) */
    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
    }

    /* share */
    $$('[data-share]', el).forEach(b => b.addEventListener('click', async () => {
      const data = { title: document.title, url: window.location.href };
      try {
        if (navigator.share) await navigator.share(data);
        else { await navigator.clipboard.writeText(data.url); toast(T.strings.copied); }
      } catch (e) {}
    }));
  }

  /* ---------- Product recommendations ---------- */
  $$('[data-recommendations]').forEach(async (wrap) => {
    try {
      const html = await fetch(wrap.dataset.url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        wrap.innerHTML = fresh.innerHTML;
        $$('[data-slider]', wrap).forEach(initSlider);
      } else {
        { const sec = wrap.closest('.sec, .section'); if (sec) sec.hidden = true; }
      }
    } catch (e) {}
  });

  /* Demo product ADD buttons */
  document.addEventListener('click', (e) => { if (e.target.closest('[data-demo-add]')) { e.preventDefault(); toast(T.strings.demoAdd || 'Demo product'); } });

  /* ---------- Reviews (built-in) ---------- */
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-review-open]');
    if (o) { const w = document.getElementById(o.getAttribute('aria-controls')); if (w) { w.hidden = !w.hidden; o.setAttribute('aria-expanded', !w.hidden); if (!w.hidden) w.scrollIntoView({ behavior: 'smooth', block: 'center' }); } return; }
    const m = e.target.closest('[data-review-more]');
    if (m) { const l = $('[data-review-list]'); const per = parseInt((l && l.dataset.per) || 6, 10); const hid = $$('.rv-item[hidden]', l).slice(0, per); hid.forEach(x => x.hidden = false); if (!$$('.rv-item[hidden]', l).length) m.remove(); }
  });
  { const ok = $('[data-review-success]'); if (ok) { const w = ok.closest('#ReviewFormWrap'); if (w) { w.hidden = false; w.scrollIntoView({ block: 'center' }); } } }

  /* ---------- Wishlist (no app, stored in browser) ---------- */
  const WKEY = 'scandic:wishlist';
  const wRead = () => { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } };
  const wWrite = (l) => { try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {} };
  function wPaint() {
    const list = wRead();
    $$('[data-wish]').forEach(b => { const on = list.includes(b.dataset.wish); b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    $$('[data-wish-count]').forEach(c => { c.textContent = list.length; c.classList.toggle('is-empty', !list.length); });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    let list = wRead(); const h = b.dataset.wish;
    const on = list.includes(h);
    list = on ? list.filter(x => x !== h) : [h].concat(list).slice(0, 100);
    wWrite(list); wPaint();
    toast(on ? (T.strings.wishRemoved || 'Removed') : (T.strings.wishAdded || 'Added'));
    const grid = $('[data-wishlist-grid]');
    if (grid && on) { const card = b.closest('[data-product-card]'); card && card.remove(); if (!grid.children.length) { const em = $('[data-wishlist-empty]'); if (em) em.hidden = false; } }
  });
  wPaint();
  (async () => {
    const grid = $('[data-wishlist-grid]');
    if (!grid) return;
    const list = wRead();
    const empty = $('[data-wishlist-empty]');
    if (!list.length) { if (empty) empty.hidden = false; return; }
    const html = await Promise.all(list.map(h => fetch(root + '/products/' + encodeURIComponent(h) + '?view=card-fragment').then(r => r.ok ? r.text() : '').catch(() => '')));
    grid.innerHTML = html.join('');
    if (!grid.children.length && empty) empty.hidden = false;
    wPaint();
  })();

  /* Collection filters: auto-apply on desktop, apply button on mobile drawer */
  const facetForm = $('[data-facet-form]');
  const facets = $('#Facets');
  const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
  function facetUrl(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
    const q = params.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }
  if (facetForm) {
    let ft;
    const go = () => { const m = $('.coll-main'); m && m.classList.add('is-loading'); window.location.href = facetUrl(facetForm); };
    facetForm.addEventListener('change', (e) => {
      if (isMobile()) return;
      clearTimeout(ft);
      ft = setTimeout(go, e.target.type === 'number' ? 600 : 50);
    });
    facetForm.addEventListener('submit', (e) => { e.preventDefault(); go(); });
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-facets-toggle]');
    if (!t || !facets) return;
    const open = !facets.classList.contains('is-open');
    facets.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
    $$('.facets-toggle').forEach(b => b.setAttribute('aria-expanded', open));
  });

  /* Collection sort */
  $$('[data-sort]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    const hidden = $('[data-facet-form] input[name="sort_by"]');
    if (hidden) hidden.value = sel.value;
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* Address forms (customer account) */
  $$('[data-address-toggle]').forEach(b => b.addEventListener('click', () => {
    const t = document.getElementById(b.dataset.addressToggle);
    if (t) t.hidden = !t.hidden;
  }));
  $$('[data-address-delete]').forEach(b => b.addEventListener('click', () => {
    if (!confirm(b.dataset.confirm || 'Delete this address?')) return;
    const f = document.createElement('form');
    f.method = 'post'; f.action = b.dataset.addressDelete;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f); f.submit();
  }));
  $$('[data-country-select]').forEach(sel => {
    const provSel = document.getElementById(sel.dataset.provinceTarget);
    const wrap = provSel && provSel.closest('.field');
    const fill = () => {
      if (!provSel) return;
      const opt = sel.options[sel.selectedIndex];
      const provs = opt ? JSON.parse(opt.dataset.provinces || '[]') : [];
      provSel.innerHTML = provs.map(p => '<option value="' + p[0] + '">' + p[1] + '</option>').join('');
      if (wrap) wrap.hidden = provs.length === 0;
      if (provSel.dataset.default) provSel.value = provSel.dataset.default;
    };
    if (sel.dataset.default) sel.value = sel.dataset.default;
    sel.addEventListener('change', fill);
    fill();
  });

  /* Recover password toggle on login page */
  function checkRecover() {
    const rec = $('#RecoverForm'), log = $('#LoginGate');
    if (!rec) return;
    const show = window.location.hash === '#recover';
    rec.hidden = !show;
    if (log) log.hidden = show;
  }
  window.addEventListener('hashchange', checkRecover);
  checkRecover();
  $$('[data-recover-cancel]').forEach(a => a.addEventListener('click', (e) => {
    e.preventDefault();
    history.replaceState(null, '', window.location.pathname);
    checkRecover();
  }));

  /* Cart back arrow: go back if the visitor came from this store */
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-cart-back]');
    if (!a) return;
    try {
      if (document.referrer && new URL(document.referrer).host === window.location.host && history.length > 1) {
        e.preventDefault();
        history.back();
      }
    } catch (err) {}
  });
})();
